import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Admin API uses a JWT stored in localStorage (Authorization header)
export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("mova_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
